import type { WheelEvent as ReactWheelEvent } from 'react'

/**
 * Prevents mouse wheel / trackpad scroll from changing a focused `type="number"` input.
 * Keyboard arrows and typing are unaffected. Call from `onWheel` on number inputs.
 */
export function preventNumberInputWheel(
 event: ReactWheelEvent<HTMLInputElement> | WheelEvent
): void {
 const el =
 event.currentTarget instanceof HTMLInputElement
 ? event.currentTarget
 : event.target
 if (
 el instanceof HTMLInputElement &&
 el.type === 'number' &&
 el === document.activeElement
 ) {
 event.preventDefault()
 }
}

/** Document-level guard for native `<input type="number">` not using shared Input components. */
export function installGlobalNumberInputWheelGuard(): () => void {
 const handler = (event: WheelEvent) => {
 preventNumberInputWheel(event)
 }
 window.addEventListener('wheel', handler, { passive: false })
 return () => window.removeEventListener('wheel', handler)
}
